module.exports = __webpack_public_path__ + "static/flags/FM-c2d8132d692249f56191b868c94bbb40.gif";